export class Comment {
    id: number;
    ticketId: number | null;
    name: string;
    content: string;
    userId?: number; // 👈 ADICIONADO

    constructor(
        id: number,
        ticketId: number | null,
        name: string,
        content: string,
        userId?: number // 👈 ADICIONADO
    ) {
        this.id = id;
        this.ticketId = ticketId;
        this.name = name;
        this.content = content;
        this.userId = userId;
    }

    public static get EMPTY(): Comment {
        return new Comment(0, null, "", "", undefined);
    }

    hasValidValue(): boolean {
        return (
            !!this.name &&
            this.name.trim().length > 0 &&
            !!this.content &&
            this.content.trim().length > 0
        );
    }
}